const cache = {};

const EditorCache = {
   get: id => {
      return cache[id];
   },

   set: (id, handle) => {
      cache[id] = handle;
      return handle;
   },

   getOrCreate: (id, createCallback) => {
      if (EditorCache.get(id)) {
         return EditorCache.get(id);
      }
      return EditorCache.set(id, createCallback());
   },

   delete: id => {
      delete cache[id];
   },
};

export default EditorCache;
